<div class="result-container" *ngIf="!loading && generatedDeliverable; else loader">
  <div class="success-animation">
    <div class="checkmark-circle">
      <div class="checkmark"></div>
    </div>
  </div>

  <h1>Votre livrable est prêt</h1>
  <p class="subtitle">
    Votre livrable personnalisé a été généré avec succès.
  </p>


  <div class="actions">
    <button class="action-btn primary" (click)="downloadPdf()" [disabled]="!generatedDeliverable.pdfUrl">
      <span class="text">
        <strong>Télécharger le PDF</strong>
        <small>Votre livrable au format PDF</small>
      </span>
    </button>

    <button class="action-btn secondary" [class.copied]="linkCopied" (click)="copyGammaLink()">
      <span class="text">
        <strong>{{ linkCopied ? 'Lien copié !' : 'Copier le lien Gamma' }}</strong>
        <small>À partager avec votre formateur</small>
      </span>
    </button>
  </div>

  <div class="info-box">
    <h4>Information</h4>
    <p>
      Copiez le lien Gamma et partagez-le avec votre formateur. Il pourra consulter
      et éventuellement faire des retouches sur votre livrable avant la présentation au jury.
    </p>
  </div>

  <div class="back-action">
    <app-button [outlined]="true" text="Retour à la formation" (onClick)="goBack()"></app-button>
  </div>
</div>

<ng-template #loader>
  <app-loader></app-loader>
</ng-template>
